import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobCompletionDetailReport'
import Component from 'components/Reports/JobCompletionDetailReport'

export default createListViewContainer({ actions, selectors: selectors.jobCompletionDetailReport })(Component)
